module.exports = __webpack_public_path__ + "static/media/SpaceMono-Bold.450f757b.ttf";